import { render, staticRenderFns } from "./FilesUploadGallery.vue?vue&type=template&id=22b39acc&scoped=true&"
import script from "./FilesUploadGallery.vue?vue&type=script&lang=js&"
export * from "./FilesUploadGallery.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploadGallery.vue?vue&type=style&index=0&id=22b39acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b39acc",
  null
  
)

export default component.exports